import { IHttpService } from 'angular';

import { ServiceLocator } from '../../app/ServiceLocator';
import { IResult } from '../../ts/ServerApi/types/IResponse';

export type FavoriteRepresentation = IResult & {
  contentId: string,
  contentType: string,
  position?: Number
};

// TODO: we will need to replace this with the Monolith/Kube relative path once configured
// Integration Tests: /content-favorites/graphql
// Local Development: http://localhost:9090/graphql
const FAVORITES_URL = '/content-favorites/graphql';

export class FavoritesResource {
  private http = ServiceLocator.get<IHttpService>('$http');

  public getFavorites(userId: string) : ng.IPromise<Array<FavoriteRepresentation>>{
    const requestConfig: ng.IRequestConfig = {
      method: 'POST',
      data: this.buildFavoritesByUserQuery(userId),
      url: FAVORITES_URL,
    };

    return this.http(requestConfig).then((response: any)=> {
      return this.mapAll(response, 'favoriteByUser');
    });
  }

  public add(favorite: FavoriteRepresentation, userId: string): ng.IPromise<FavoriteRepresentation> {

    const requestConfig: ng.IRequestConfig = {
      method: 'POST',
      data: this.buildCreateQuery(favorite, userId),
      url: FAVORITES_URL,
    };

    return this.http(requestConfig).then((response: any)=> {
      return this.mapOne(response, 'createFavorite');
    });
  }

  public remove(favorite: FavoriteRepresentation, userId: string): ng.IPromise<IResult> {
    const requestConfig: ng.IRequestConfig = {
      method: 'POST',
      data: this.buildDeleteQuery(favorite, userId),
      url: FAVORITES_URL,
    };

    return this.http(requestConfig).then((response: any)=> {
      return this.mapOne(response, 'deleteFavorite');
    });
  }

  private buildCreateQuery(favorite: FavoriteRepresentation, userId: string): any {
    return {
      'query': `mutation FavoriteMutation {
        createFavorite(
          user: "${userId}",
          type: "${favorite.contentType}",
          contentId: "${favorite.contentId}"
        ) {
          contentId
          type
          sortPosition
        }
      }`
    };
  }

  private buildDeleteQuery(favorite: FavoriteRepresentation, userId: string): any {
    return {
      query: `mutation FavoriteMutation {
        deleteFavorite(
          user: "${userId}",
          type: "metric",
          contentId: "${favorite.contentId}"
        ) {
          contentId
          type
          sortPosition
        }
      }`
    };
  }

  private buildFavoritesByUserQuery(userId: string): any {
    return {
      query: `{
        favoriteByUser(user: ${userId}) {
          contentId
          type
          sortPosition
        }
      }`
    };
  }

  private mapAll(response: any, queryName: string): Array<FavoriteRepresentation> {
    const createdFavorites = response.data.data[queryName];
    const all: Array<FavoriteRepresentation> = [];
    for(let item of createdFavorites){
      all.push(this.map(item));
    }

    return all;
  }

  private mapOne(response: any, queryName: string): FavoriteRepresentation {
    const createdFavorite = response.data.data[queryName];
    return this.map(createdFavorite);
  }

  private map(createdFavorite: any): FavoriteRepresentation{
    return {
      contentId: createdFavorite.contentId,
      contentType: createdFavorite.contentType,
      position: createdFavorite.sortPosition,
    };
  }
}
